import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgAcneThreeGlyph from './svgs/AcneThreeGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var acneThreeGlyph = (props => useIcon(SvgAcneThreeGlyph, SvgAcneThreeGlyph, props));

export { acneThreeGlyph as default };
